// extracted by mini-css-extract-plugin
module.exports = {"SMainMenuButton":"MainMenuButton_SMainMenuButton__7A_tm","SHamburger":"MainMenuButton_SHamburger__DOoOj"};